import { render, staticRenderFns } from "./DashboardNumbers.vue?vue&type=template&id=cdcb0c90&scoped=true"
import script from "./DashboardNumbers.vue?vue&type=script&lang=ts"
export * from "./DashboardNumbers.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNumbers.vue?vue&type=style&index=0&id=cdcb0c90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcb0c90",
  null
  
)

export default component.exports